import { dateFormate } from '../../../utils/helper';
import CommonBadges from '../../Shared/Badges/index';

export const TableColumns = [
    {
        dataField: 'index',
        text: 'S.No.',
        formatter: (cell, row, rowIndex) => rowIndex + 1,
        headerAlign: 'center',
        align: 'center',
    },
    {
        dataField: 'company',
        text: 'Company',
        headerAlign: 'center',
        align: 'center',
        sort: true,
    },
    {
        dataField: 'lead_date',
        text: 'Date',
        headerAlign: 'center',
        align: 'center',
        sort: true,
        formatter: (cell, row, rowIndex) => {
            return <>{dateFormate(row?.lead_date, 'DD-MM-YYYY hh:mm A')}</>;
        },
    },
    {
        dataField: 'id',
        text: 'Id',
        headerAlign: 'center',
        align: 'center',
        sort: true,
    },
    {
        dataField: 'Verified',
        text: 'Verified',
        headerAlign: 'center',
        align: 'center',
        sort: true,
        formatter: (cell, row, rowIndex) => {
            return (
                <>
                    {
                        <CommonBadges
                            color={row?.varified_ops === 'no' ? 'warning' : 'success'}
                            value={row?.varified_ops}
                        />
                    }
                </>
            );
        },
    },
    {
        dataField: 'Verified By',
        text: 'Verified By',
        headerAlign: 'center',
        align: 'center',
        sort: true,
        formatter: (cell, row, rowIndex) => {
            return <>{row?.varified_ops_by}</>;
        },
    },
];
